angular.module('qkr').factory('loyaltyCardService', ($http, appConfig, $q, utils) => ({

        loyaltyCardList: [],
        loyaltyCardSelectedProductList: [],

        createPunchCardRewardScheme(createPunchCardRewardSchemeCommand) {
            return $http.post(appConfig.apiUrl + 'punchCard/create', createPunchCardRewardSchemeCommand);
        },

        updatePunchCardRewardScheme(updatePunchCardRewardSchemeCommand) {
            return $http.post(appConfig.apiUrl + 'punchCard/update', updatePunchCardRewardSchemeCommand);
        },

        getPunchCardIconList() {
            return $http.get(appConfig.apiUrl + 'punchCard/getPunchCardIconList', {
                withCredentials: true
            }).then((response) => response.data);
        },

        emptyLoyaltyCardList() {
            const self = this;
            self.loyaltyCardList = [];
        },
        
        loadLoyaltyCardList() {
            const self = this;
            if (utils.hasNoValue(self.loyaltyCardList) || self.loyaltyCardList.length < 1) {
                return $http.get(appConfig.apiUrl + 'punchCard/list', {
                    withCredentials: true
                }).then((response) => {
                    self.loyaltyCardList = response.data;
                    self.setSelectedProductsList(response.data);
                    return self.loyaltyCardList;
                });
            } else {
                const deferred = $q.defer();
                deferred.resolve(self.loyaltyCardList);
                return deferred.promise;
            }
        },

        setSelectedProductsList(list) {
            const self = this;
            self.loyaltyCardSelectedProductList = [];
            angular.forEach(list, (punchCard) => {
                angular.forEach(punchCard.products.redeemableInventoryItemIds, (redeemableInventoryItemId) => {
                    self.loyaltyCardSelectedProductList.push({id: redeemableInventoryItemId.id, loyaltyCardName: punchCard.schemeName});
                });
            });
        },

        getSelectedProductsList() {
            const self = this;
            return self.loyaltyCardSelectedProductList;
        },

        getLoyaltyCard(loyaltyCardId) {
            const self = this;
            for (let i = 0; i < self.loyaltyCardList.length; i++) {
                if (self.loyaltyCardList[i].id == loyaltyCardId) {
                    return angular.copy(self.loyaltyCardList[i]);
                }
           }
           return null;
        },

        deleteLoyaltyCard(loyaltyCardId) {
            return $http.post(appConfig.apiUrl + 'punchCard/delete', {id: loyaltyCardId});
        },

        deactivateLoyaltyCard(loyaltyCardId) {
            return $http.post(appConfig.apiUrl + 'punchCard/deactivate', {id: loyaltyCardId});
        },

        activateLoyaltyCard(loyaltyCardId, expiryDate) {
            const activateCommand = {
                id: loyaltyCardId,
                expiryDate
            };
            return $http.post(appConfig.apiUrl + 'punchCard/activate', activateCommand);
        }

    }));



// WEBPACK FOOTER //
// ./src/loyalty/services/loyaltyCard.services.js